import { useContext, useEffect, useState } from "react";
import { NewTableContext } from ".";
import { IColumnNewTable } from "./interfaces";
import { makeid } from "utils/random";

interface ITableHeadProps extends React.HTMLProps<HTMLElement> {
  columns: IColumnNewTable[];
  hasExpandRow?: boolean;
  isAction?: boolean;
}

export default function TableHead({ columns , hasExpandRow, isAction, ...props}:ITableHeadProps){
  return (
    <thead>
      {props.children}
      <tr className="text-center">
        {hasExpandRow && <th className="newtable-fit-cell"></th>}
        {columns.map((column, key)=>{
          let style = {...column.styleHead};
          if(column.headerNowrap)style.whiteSpace = "nowrap";
          return <th key={key} style={style}>{column.text}</th>
        })}
      </tr>
    </thead>
  );
}

export function TableHeaderColumn({...props}: IColumnNewTable){
  const { addColumns, removeColumn, getOrder } = useContext(NewTableContext);
  const [ order ] = useState(()=>{
    if(getOrder) return getOrder()
    return 0;
  });
  const [ ID ] = useState(`column-${makeid(5)}-${makeid(5)}`);
  const [ internalProps, setInternalProps ] = useState({...props})
  
  useEffect(()=>{
    setInternalProps((old:any)=>{
      if(JSON.stringify(old) !== JSON.stringify(props))
        return props;
      return old;
    })
  },[props]);

  useEffect(()=>{
    // console.log(ID,"add");
    let id = ID;
    if(addColumns) addColumns({...internalProps, text: internalProps.children, id, order});
    return () => {
      // console.log(ID,"remove");
      if(removeColumn) removeColumn(id);
    }
  },[addColumns, removeColumn, internalProps, ID, order]);

  
  return (<></>);
}
